import { Box, IconButton, Stack, Tooltip, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useDownloadAttachment } from '../../api/aws/comments/useDownloadAttachments'
import GetAppIcon from '@mui/icons-material/GetApp'
import DeleteIcon from '@mui/icons-material/Delete'

interface Attachment {
  id: string
  iconLink: string
  mimeType: string
  name: string
  thumbnailLink: string
  url: string
}

interface RenderPdfThumbnailProps {
  attachment: Attachment
  onOpenViewer: (index: number) => void
  onDeleteAttachment: (index: number) => void
  getThumbnail: (attachment: Attachment) => React.ReactElement

  attachmentIndex: number
  isNoteCreator: boolean
}

const RenderPdfThumbnail: React.FC<RenderPdfThumbnailProps> = ({
  attachment,
  attachmentIndex,
  onDeleteAttachment,
  onOpenViewer,
  getThumbnail,
  isNoteCreator,
}) => {
  const theme = useTheme()
  const { downloadAttachment } = useDownloadAttachment()
  return (
    <Tooltip
      key={attachment.url}
      placement="top"
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" noWrap sx={{ maxWidth: 200, color: theme.palette.text.primary }}>
            {attachment.name}
          </Typography>
          {isNoteCreator && (
            <IconButton
              size="small"
              sx={{ color: 'text.primary' }}
              onClick={e => {
                e.stopPropagation()
                onDeleteAttachment(attachmentIndex)
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          )}

          <IconButton
            size="small"
            sx={{ color: 'text.primary' }}
            onClick={e => {
              e.stopPropagation()
              downloadAttachment(attachment.url, attachment.name)
            }}
          >
            <GetAppIcon fontSize="small" />
          </IconButton>
        </Box>
      }
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: theme.palette.background.default,
            color: theme.palette.text.primary,
            p: 1,
            borderRadius: 1,
          },
        },
      }}
    >
      <Stack
        onClick={() => onOpenViewer(attachmentIndex)}
        sx={{
          width: '100%',
          height: '100%',
          maxHeight: 24,
          maxWidth: 20,
          mx: 0.5,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: 1,
          overflow: 'hidden',
          cursor: 'pointer',
        }}
        direction={'column'}
      >
        {getThumbnail(attachment)}
      </Stack>
    </Tooltip>
  )
}

export default RenderPdfThumbnail
